module.exports = __webpack_public_path__ + "img/IMG_5915.c4532006.jpg";